import FederatedMFE from 'common/components/FederatedMFE';
import { injectReducerAsync } from 'app/reduxStore';

const NotificationsPage: React.FC = () => (
  <FederatedMFE
    urlKey="REACT_APP_NOTIFICATIONS_MFE_URL"
    scope="notifications"
    reducerModule="./NotificationsReducers"
    componentModule="./NotificationsLandingPage"
    injectionReducerCb={injectReducerAsync}
  />
);

export default NotificationsPage;
